import { type FlowOutputBlock, FlowOutputBlockConfigSchema } from 'flow-schema';

import { OutputBlockFormFields } from './FormFields';
import { OutputBlockOutputContent } from './OutputContent';
import { OutputBlockDocumentationMarkdown } from './documentation';
import { defaultOutputNodeLabelPrefix, getDefaultOutputNodeConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const outputConfig: BlockConfigProps<FlowOutputBlock['config']> = {
  nodeHandles: [{ type: 'target' }],
  defaultLabelPrefix: defaultOutputNodeLabelPrefix,
  defaultConfig: getDefaultOutputNodeConfig(),
  configFields: {
    schema: FlowOutputBlockConfigSchema,
    FormFields: OutputBlockFormFields,
  },
  documentationMarkdown: OutputBlockDocumentationMarkdown,
  OutputContentComponent: OutputBlockOutputContent,
};
